'use client'

import React, { useEffect } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import {
    useChangePasswordMutation,
    useCheckUserMutation,
} from '@/shared/api-rtk/index.js'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'

export const LoginSettings = () => {
    //initial and lib
    const [checkUser] = useCheckUserMutation()
    const [changePassword] = useChangePasswordMutation()
    const initialPassword = 'qwerty12345'
    const { userInfo, logoutUser } = useGetIsAuthUser()

    // state
    const [user, setUser] = React.useState({
        email: '',
        customer_id: '',
    })
    const [passwordData, setPasswordData] = React.useState(initialPassword)
    const [password, setPassword] = React.useState(true)

    useEffect(() => {
        checkUser(userInfo)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setUser({
                        email: res.data.email,
                        customer_id: res.data.customer_id,
                    })
                }
            })
    }, [])

    const handleChangePassword = (e) => {
        setPasswordData(e.target.value)
    }
    const handleActivePassword = () => {
        setPasswordData('')
        if (!password) {
            setPasswordData(initialPassword)
        }
        setPassword(!password)
    }

    const handleSaveData = () => {
        if (passwordData.length < 5) {
            return TOAST_ERROR('Слишком короткий пароль')
        }
        setPassword(true)
        const changePasswordData = {
            customer_id: user.customer_id,
            password: passwordData,
        }
        changePassword(changePasswordData)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    logoutUser()
                    return TOAST_SUCCESS('Пароль успешно изменён')
                }
            })
    }

    return (
        <div className={'LoginSettings'}>
            <h3>Настройки входа</h3>
            <div className={'inputs'}>
                <div className={'input-item email'}>
                    <div className={'header'}>
                        <label htmlFor="email">E-Mail</label>
                    </div>
                    <Form.Control
                        type={'email'}
                        id={'email'}
                        disabled={true}
                        value={user.email}
                    />
                </div>
                <div className={'input-item password'}>
                    <div className={'header'}>
                        <label htmlFor="password">Пароль</label>
                        <span onClick={handleActivePassword}>
                            {password ? 'Изменить' : 'Отменить'}
                        </span>
                    </div>
                    <Form.Control
                        type={'password'}
                        id={'password'}
                        disabled={password}
                        placeholder={'Введите новый пароль'}
                        value={passwordData}
                        onChange={handleChangePassword}
                    />
                </div>
            </div>
            <button
                onClick={handleSaveData}
                className={`button-save${!password ? '' : ' hide'}`}
            >
                Сохранить изменения
            </button>
        </div>
    )
}
